export default __webpack_public_path__ + "static/media/CREDITZ-WHITE.705239c4.png";